export default function (data) {
  var self = this;

  self.selectedTerm = ko.observable();
  self.selectedInstitution = ko.observable();
  self.selectedCourse = ko.observable();
  self.selectedCoursework = ko.observable();
  self.selectedSession = ko.observable();
  self.filteredCourses = ko.observableArray();
  self.filteredCoursework = ko.observableArray();
  self.filteredSessions = ko.observableArray();
  self.courseId = document.getElementById('course_id').value;
  self.cloneType = document.getElementById('clone_type').value;

  self.updateCourses = function(data) {
    self.filteredCourses.removeAll();
    document.getElementById('js-select-course').classList.remove('disabled');
    self.filteredCourses(data.courses);
  };

  self.updateCoursework = function(data) {
    self.filteredCoursework.removeAll();
    document.getElementById('js-select-coursework').classList.remove('disabled');
    self.filteredCoursework(data.coursework);
  };

  self.updateSessions = function(data) {
    self.filteredSessions.removeAll();
    document.getElementById('js-select-session').classList.remove('disabled');
    self.filteredSessions(data.lectures);
  };

  self.getCourseList = function() {
    var data = {};
    var url = Kadenze.Routes.search_cloner_courses_path();
    if (self.selectedTerm()) {
      data.term_id = self.selectedTerm();
    } else if (self.selectedInstitution()) {
      data.institution_id = self.selectedInstitution();
    } else {
      return false;
    }
    var method = 'POST';

    var request = new Kadenze.AjaxRequest({
      type: method,
      url: url,
      dataAsJSON: true,
      data: data,
      loadingIndicator: {
        container: $('#main-pjax-container'), // jQuery Object, holder for the loader
        positionTop: 'fixed' // String, 'fixed' covers the whole page, 'top' is relative to the container
      }
    });

    request.fail(function(xhr, textstatus, message) {
      if (textstatus === 'timeout') {
        console.warn('Ajax request timed out:');
        console.log(xhr);
        new Kadenze.Notice.error($.extend({}, {}, {message: Kadenze.I18n.t('notice.unexpected_error')}));
      } else {
        new Kadenze.Notice.error(xhr.responseJSON);
      }
    });

    request.done(function(data) {
      self.updateCourses(data);
    });
  };

  self.cloneItem = function() {
    var data = {};
    var url;
    data.course_id = self.courseId;
    if(self.cloneType === 'coursework') {
      if(!self.selectedCoursework()){
        return new Kadenze.Notice.info({title: 'Missing required field', message: 'Please select a coursework'});
      }
      data.coursework_id = self.selectedCoursework();
      url = Kadenze.Routes.cloner_coursework_index_path();
    } else {
      if(!self.selectedSession()){
        return new Kadenze.Notice.info({title: 'Missing required field', message: 'Please select a session'});
      }
      data.lecture_id = self.selectedSession();
      url = Kadenze.Routes.cloner_sessions_path();
    }

    var method = 'POST';

    var request = new Kadenze.AjaxRequest({
      type: method,
      url: url,
      dataAsJSON: true,
      data: data,
      timeout: 30000,
      loadingIndicator: {
        container: $('#main-pjax-container'), // jQuery Object, holder for the loader
        positionTop: 'fixed' // String, 'fixed' covers the whole page, 'top' is relative to the container
      }
    });

    request.fail(function(xhr, textstatus, message) {
      var url;
      var courseId = document.getElementById('course_id').value;
      if (textstatus === 'timeout') {
        console.warn('Ajax request timed out:');
        console.log(xhr);
        var titleMsg = 'Long running import';
        var timeoutMsg = 'Your import is taking a while to complete, we are redirecting you, please refresh the page if it doesn\'t show up';
        var completeCb = function() {
          if(self.cloneType === 'coursework') {
            url = Kadenze.Routes.course_coursework_index_path(courseId);
          } else {
            url = Kadenze.Routes.course_sessions_path(courseId);
          }
          Kadenze.Request.pjax({url: url, container: '#main-pjax-container'});
        };
        var confirmOpts = {title: titleMsg, hide_cancel: true};
        Kadenze.UIUtil.confirmAction(timeoutMsg, completeCb, undefined, confirmOpts);
      } else {
        new Kadenze.Notice.error(xhr.responseJSON);
      }
    });

    request.done(function(data) {
      var url;
      var courseId = document.getElementById('course_id').value;
      if(self.cloneType === 'coursework') {
        new Kadenze.Notice.success({ message: 'Coursework copied!' });
        url = Kadenze.Routes.course_coursework_index_path(courseId);
      } else {
        new Kadenze.Notice.success({ message: 'Session copied!' });
        url = Kadenze.Routes.course_sessions_path(courseId);
      }
      Kadenze.Request.pjax({url: url, container: '#main-pjax-container'});
    });
  };

  self.getCloneList = function(){
    var url;
    var data = {};
    if(self.cloneType === 'coursework') {
      if(self.selectedCourse()){
        data.course_id = self.selectedCourse();
      } else {
        return false;
      }
      url = Kadenze.Routes.search_cloner_coursework_index_path();
    } else {
      data.course_id = self.selectedCourse();
      data.lecture_id = self.selectedSession();
      url = Kadenze.Routes.search_cloner_sessions_path();
    }

    var method = 'POST';

    var request = new Kadenze.AjaxRequest({
      type: method,
      url: url,
      dataAsJSON: true,
      data: data,
      loadingIndicator: {
        container: $('#main-pjax-container'), // jQuery Object, holder for the loader
        positionTop: 'fixed' // String, 'fixed' covers the whole page, 'top' is relative to the container
      }
    });

    request.fail(function(xhr, textstatus, message) {
      if (textstatus === 'timeout') {
        console.warn('Ajax request timed out:');
        console.log(xhr);
        new Kadenze.Notice.error($.extend({}, {}, {message: Kadenze.I18n.t('notice.unexpected_error')}));
      } else {
        new Kadenze.Notice.error(xhr.responseJSON);
      }
    });

    request.done(function(data) {
      if(self.cloneType === 'coursework') {
        self.updateCoursework(data);
      } else {
        self.updateSessions(data);
      }
    });
  };

  self.selectedTerm.subscribe(self.getCourseList);
  self.selectedInstitution.subscribe(self.getCourseList);
  self.selectedCourse.subscribe(self.getCloneList);

  const __construct = function(that) {
    console.log('constructor called for ClonerSelectVM');
    that.terms = JSON.parse($('#terms_json').val());
    that.institutions = JSON.parse($('#institutions_json').val());
  }(this);
}

